export const multasColumns = [
    { field: "id", headerName: "ID", width: 20 },
    {
      field: "inicioM",
      headerName: "Inicio",
      width: 180,
    },
    {
      field: "finM",
      headerName: "Fin",
      width: 110,
    }
];